var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2443 7.23211L16.1386 0.527771H14.7418L9.62379 6.34905L5.53603 0.527771H0.821289L7.00278 9.33058L0.821289 16.3611H2.21814L7.62291 10.2136L11.9399 16.3611H16.6547L10.2443 7.23211ZM8.3311 9.40813L7.70479 8.53157L2.72144 1.55668H4.86691L8.88853 7.18565L9.51484 8.0622L14.7425 15.379H12.597L8.3311 9.40813Z",
    fill: "#484848"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcX);
export default __webpack_public_path__ + "static/media/ic_x.51fbedaa.svg";
export { ForwardRef as ReactComponent };